export const triggerDownload = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = "";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const filterReportsByCampaignId = (reports, query) => {
  const safeReports = Array.isArray(reports) ? reports : [];

  if (!query.trim()) {
    return safeReports;
  }

  return safeReports.filter((item) =>
    (item.campaign_id || "").toLowerCase().includes(query.toLowerCase())
  );
};

export const paginateReports = (reports, currentPage, recordsPerPage) => {
  const safeReports = Array.isArray(reports) ? reports : [];
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  return {
    indexOfFirstRecord,
    currentRecords: safeReports.slice(indexOfFirstRecord, indexOfLastRecord),
    totalPages: Math.ceil(safeReports.length / recordsPerPage),
  };
};
